 	// install a JSONP callback for chunk loading
 	var parentJsonpFunction = window["webpackJsonp"];
 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [], result;
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
 		while(resolves.length) {
 			resolves.shift()();
 		}
 		if(executeModules) {
 			for(i=0; i < executeModules.length; i++) {
 				result = __webpack_require__(__webpack_require__.s = executeModules[i]);
 			}
 		}
 		return result;
 	};

 	// The module cache
 	var installedModules = {};

 	// objects to store loaded and loading chunks
 	var installedChunks = {
 		68: 0
 	};

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		var threw = true;
 		try {
 			modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
 			threw = false;
 		} finally {
 			if(threw) delete installedModules[moduleId];
 		}

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData === 0) {
 			return new Promise(function(resolve) { resolve(); });
 		}

 		// a Promise means "currently loading".
 		if(installedChunkData) {
 			return installedChunkData[2];
 		}

 		// setup Promise in chunk cache
 		var promise = new Promise(function(resolve, reject) {
 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
 		});
 		installedChunkData[2] = promise;

 		// start chunk loading
 		var head = document.getElementsByTagName('head')[0];
 		var script = document.createElement('script');
 		script.type = 'text/javascript';
 		script.charset = 'utf-8';
 		script.async = true;
 		script.timeout = 120000;

 		if (__webpack_require__.nc) {
 			script.setAttribute("nonce", __webpack_require__.nc);
 		}
 		script.src = __webpack_require__.p + "" + ({"0":"bundles/pages/indexOld.js","1":"bundles/pages/index.js","2":"bundles/pages/single-fund.js","3":"bundles/pages/single-fund-new.js","4":"bundles/pages/grow-wealth.js","5":"bundles/pages/dashboard.js","6":"bundles/pages/plan.js","7":"bundles/pages/search.js","8":"bundles/pages/compare-funds.js","9":"bundles/pages/kyc.js","10":"bundles/pages/sip-calculator.js","11":"bundles/pages/mfHome.js","12":"bundles/pages/nfos.js","13":"bundles/pages/plan-v2.js","14":"bundles/pages/save-taxes.js","15":"bundles/pages/amc.js","16":"bundles/pages/amcNew.js","17":"bundles/pages/profile.js","18":"bundles/pages/currency.js","19":"bundles/pages/elss-calculator.js","20":"bundles/pages/personalized-plan.js","21":"bundles/pages/personalised-plan.js","22":"bundles/pages/f2s.js","23":"bundles/pages/invest.js","24":"bundles/pages/google-auth.js","25":"bundles/pages/postFiling.js","26":"bundles/pages/whatsapp-confirmation.js","27":"bundles/pages/nfoDetails.js","28":"bundles/pages/mandate.js","29":"bundles/pages/_error.js","30":"bundles/pages/filing-to-save.js","31":"bundles/pages/currency/components/banner/Banner.js","32":"bundles/pages/currency/components/Conversionfold/Graph/Graph.js","33":"bundles/pages/complete-kyc.js","34":"bundles/pages/rent-page.js","35":"bundles/pages/amcs.js","36":"bundles/pages/currency/components/FAQ/Faq.js","37":"bundles/pages/special-referral.js","38":"bundles/pages/login.js","39":"bundles/pages/currency/components/Conversionfold/Graph/graphConstant.js","40":"bundles/pages/currency/components/Conversionfold/Converter/converter.js","41":"bundles/pages/currency/components/Aboutcurrenies/Aboutcurrenies.js","42":"bundles/pages/currency/components/Popularconversions/Popularconversions.js","43":"bundles/pages/calculator80C.js","44":"bundles/pages/status.js","45":"bundles/pages/redirect.js","46":"bundles/pages/yesBankCrisisFaq.js","47":"bundles/pages/referral.js","48":"bundles/pages/refer.js","49":"bundles/pages/redeemSummary.js","50":"bundles/pages/paymentSuccess.js","51":"bundles/pages/payment.js","52":"bundles/pages/mandate-status.js","53":"bundles/pages/logout.js","54":"bundles/pages/indexMobile.js","55":"bundles/pages/help.js","56":"bundles/pages/demo.js","57":"bundles/pages/dashboardRedirect.js","58":"bundles/pages/currency/currencyConst.js","59":"bundles/pages/currency/components/FAQ/faqdropdown/faqdropdown.js","60":"bundles/pages/currency/components/Conversionfold/Converter/ConverterInput/ConverterInput.js","61":"bundles/pages/currency/components/Commondenominations/Commondenominations.js","62":"bundles/pages/currency/components/Aboutcurrenies/CurrencyInformation/CurrencyInformation.js","63":"bundles/pages/currency/api.js","64":"bundles/pages/complete-payment.js","65":"bundles/pages/appIssues.js","66":"bundles/pages/currency/util/recaptcha.js","67":"bundles/pages/currency/components/Navbar/Productmenu/ProductsMenu.js"}[chunkId]||chunkId) + "-" + {"0":"8d6c17404343fa57bf8b","1":"67ff4c02c64ea1552f3e","2":"33158e40c5b85628d931","3":"d7938bde55fb6729f634","4":"fdb33c8e1bc68dae510a","5":"27d7fdc043a634bcb998","6":"2358407ca6664ac56db0","7":"3e5bf0b7352a45b60eaf","8":"826687d48a6680ddd7bb","9":"b7f7129397e33a330f81","10":"403b1e4944828277c8e5","11":"0078f0d34324bb827a86","12":"942c4c66a7bee534e24a","13":"9393f32815d82270b0f0","14":"5d48c33acef1f5fec670","15":"c1cd0f013505a4d061a3","16":"df621012001f29f18162","17":"2c940eee17ed4baf5946","18":"55715100f70e5a2fdda7","19":"5867c372e2428fc1a3cb","20":"f8f459eb3aa2e0e0be52","21":"f0aa16bf1ee97227d0e6","22":"0851ca8c7cd7b98df1d0","23":"5a9f90bf1cd7406ae7c9","24":"079ceca5bf551f385254","25":"39c79260b1436c5840e1","26":"bf3e12e0aed130f706d5","27":"d86d4b89e2d9af616d9c","28":"786d32a15fa635b09b93","29":"13b9ef2cd1b94479d90d","30":"c75bf72ef4c5d3d596c7","31":"e76084c72c548b5c6cd5","32":"f0aadab718780c4e09d4","33":"4ad5d00d7e89c29e9348","34":"7cffd75f90ece254f256","35":"dfd82b4d517ec710f44f","36":"2c4e4d6ec5d5fc09ab59","37":"7a814f54121f72c148d8","38":"f22354ef53db9cc0d8dc","39":"781a77701f2ebedc1cf6","40":"0b9a7c2ac04fc1131577","41":"6b4768df0448885c06cd","42":"122554427af77b73235b","43":"c73a70a44cf1dd1fc144","44":"a198bc952538094199a8","45":"638ecf3a6de075c6435d","46":"b4359aef6fb88f49047a","47":"5cb129110474c8f1e879","48":"9696d4538317e4a8d142","49":"a315fdb71cb8af7ebcb8","50":"678df07b56688e79f51e","51":"174ceda5008a676a56f6","52":"883d4cb6a0d2f845c933","53":"ec99c0662887d8ef0a50","54":"363c7a368160845c689d","55":"ba597600cfebc684f2cf","56":"a6f8042d1fe7c0e3a4ac","57":"a257a01c0d95861cddc3","58":"02d337166488a52b5d90","59":"f4382d42e433b19fe061","60":"7401c2e55a1708e2d7d7","61":"c701d48b8ca9e62f09c5","62":"ac0d0a944b625333393d","63":"15e66443d1bab84ed5d4","64":"5d7b3f89c1117d9289a5","65":"09d9ae9a53cd8ec81e29","66":"6745e040125abb651dec","67":"bfff2cf1025fd2358c01"}[chunkId] + ".js";
 		var timeout = setTimeout(onScriptComplete, 120000);
 		script.onerror = script.onload = onScriptComplete;
 		function onScriptComplete() {
 			// avoid mem leaks in IE.
 			script.onerror = script.onload = null;
 			clearTimeout(timeout);
 			var chunk = installedChunks[chunkId];
 			if(chunk !== 0) {
 				if(chunk) {
 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
 				}
 				installedChunks[chunkId] = undefined;
 			}
 		};
 		head.appendChild(script);

 		return promise;
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, {
 				configurable: false,
 				enumerable: true,
 				get: getter
 			});
 		}
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 753);



// WEBPACK FOOTER //
// webpack/bootstrap b4abfd70abdc769ad06f